import { combineReducers } from '@reduxjs/toolkit';
import screenReducer from './screen/screenSlice';
import creativesReducer from './creatives/creativesSlice';
import campaignsReducer from './campaigns/campaignsSlice';
import userManagementReducer from './user-management/userManagementSlice';
import approvalReducer from './approval/approvalSlice';
import retargetingReducer from './retargeting/retargetingSlice';

const doohReducer = combineReducers({
  screen: screenReducer,
  creative: creativesReducer,
  campaigns: campaignsReducer,
  userManagement: userManagementReducer,
  approval: approvalReducer,
  retargeting: retargetingReducer,
  // Add other dooh-related reducers here in the future
  // analytics: analyticsReducer,
});

export default doohReducer;
